export const TECHNODES_URL = "https://technodes.pro/kontra";
